import { Network } from '@/hooks/network/useNetwork'
import { InferenceAlgorithm } from '@/services/bayesianApi/models'
import { VariableTypeSelectEntry } from '@/services/db/schema'
import { NetworkStatus } from '@/services/models/enums'
import { Connection, VariableFromBackend } from '@/types/variable'

import addTypesToVariables from './addTypeToVariables'

function convertVariablesAndTypesIntoNetwork({
  variables,
  variableTypes,
  id,
  name,
  inferenceAlgorithm,
  status,
  isMain,
  isReleaseBranch,
  defaultTransitionHalfBandPercent,
}: {
  variables: Array<VariableFromBackend>
  variableTypes: Array<VariableTypeSelectEntry>
  id: string
  name: string
  inferenceAlgorithm: InferenceAlgorithm
  status: NetworkStatus
  isMain: boolean
  isReleaseBranch: boolean
  defaultTransitionHalfBandPercent: number
}): Network {
  const variablesWithTypes = addTypesToVariables(variables, variableTypes)

  return {
    id,
    name,
    inferenceAlgorithm,
    status,
    isMain,
    isReleaseBranch,
    defaultTransitionHalfBandPercent,
    variables: variablesWithTypes,
    variableById: new Map(variablesWithTypes.map((v) => [v.id, v])),
    variableIds: new Set(variablesWithTypes.map((v) => v.id)),
    arrows: mapArrows(variablesWithTypes),
    variableTypes: variableTypes,
  }
}

function mapArrows(
  variables: Array<{ id: string; inboundArrows: Array<Connection> }>,
) {
  return new Map(
    variables.flatMap(({ id, inboundArrows }) =>
      inboundArrows.map(({ variableId, comment }) => [
        `${variableId}=>${id}`,
        {
          source: variableId,
          target: id,
          comment: comment,
        },
      ]),
    ),
  )
}

export default convertVariablesAndTypesIntoNetwork
